import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { marker as _ } from '@vandres/ngx-translate-extract-marker';

export interface IConfirmDialogData {
  title: string;
  message: string;
  okButtonText: string;
  okButtonColor: string;
  cancelButtonText: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css'],
  standalone: false
})
export class ConfirmationDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);
  data = inject<IConfirmDialogData>(MAT_DIALOG_DATA);


  okButtonText: string;
  okButtonColor: string;
  cancelButtonText: string;

  constructor() {
    const data = this.data;

    this.okButtonText = data.okButtonText || _('OK');
    this.okButtonColor = data.okButtonColor || 'primary';
    this.cancelButtonText = data.cancelButtonText || _('Cancel');
  }
}
